import PrimarySecondary from '@common/ui/PrimarySecondary';
import { Avatar } from '@mui/material';

function stringToColor(string: string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

function stringAvatar(name: string) {
  const initials = name
    .split(' ')
    .map((part) => part[0])
    .slice(0, 2)
    .join('');

  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: initials || '-',
  };
}

export interface AssessmentReportIdentityProps {
  name: string;
  email: string;
}

export default function AssessmentReportIdentity({ name, email }: AssessmentReportIdentityProps) {
  return <PrimarySecondary primary={name} secondary={email} iconSize={32} icon={<Avatar {...stringAvatar(name)} />} />;
}
